/* GSAP 3.15.0: a one-time, progressively enhanced ingredient reveal. */
(() => {
  if (window.topShakeMotion || !window.gsap || !window.IntersectionObserver) return;
  window.topShakeMotion = true;
  const instances = new Map();

  function mount(section) {
    if (instances.has(section)) return;
    const media = window.gsap.matchMedia();
    media.add('(prefers-reduced-motion: no-preference)', () => {
      const tweens = new Set();
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting);
        visible.forEach((entry, index) => {
          observer.unobserve(entry.target);
          const image = entry.target.querySelector('.top-ingredient__image');
          if (!image) return;
          // Only the photograph moves; links and copy stay readable throughout.
          const tween = window.gsap.fromTo(image,
            { y: 20, opacity: 0.55 },
            { y: 0, opacity: 1, duration: 0.75,
              delay: window.matchMedia('(min-width: 701px)').matches ? index * 0.12 : 0,
              ease: 'power2.out', clearProps: 'transform,opacity',
              onComplete: () => tweens.delete(tween) }
          );
          tweens.add(tween);
        });
      }, { threshold: 0.18 });
      section.querySelectorAll('.top-ingredient').forEach((card) => observer.observe(card));
      return () => {
        observer.disconnect();
        tweens.forEach((tween) => tween.revert());
        tweens.clear();
      };
    });
    instances.set(section, media);
  }

  function scan() {
    document.querySelectorAll('.top-shake').forEach(mount);
  }
  function dispose(section) {
    instances.get(section)?.revert();
    instances.delete(section);
  }
  scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((_, section) => {
      if (event.target.contains(section)) dispose(section);
    });
  });
})();
